export const ERRORS = Object.freeze({
    UPLOAD_TABLE: "error.inventory.upload.table",
    UPLOAD_SEND: "error.inventory.upload.send",
    CLEAR: "error.inventory.clear",
    GET_ONE_INVENTORY: "error.inventory.get.one",
    GET_TODAY_INVENTORY: "error.inventory.get.today",
});

export const UPLOAD_INVENTORY_MODES = Object.freeze({
    ADD: "add",
    REPLACE: "replace",
});
